(function () {
  var STORAGE_KEY = 'sha_selected_currency';
  var RATES_KEY = 'sha_currency_rates';
  var RATES_TTL = 1000 * 60 * 60 * 12;
  var memoryRates = null;
  var memoryBase = null;
  var ratesPromise = null;
  var refreshTimer = null;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getRoot() {
    return document.querySelector('[data-sha-currency-root]');
  }

  function parseCurrencyMap(root) {
    try {
      return JSON.parse(root.getAttribute('data-currency-map') || '{}');
    } catch (e) {
      return {};
    }
  }

  function moneyFormat(amount, currency) {
    var value = Number(amount);
    if (!isFinite(value)) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return currency + ' ' + value.toFixed(2);
    }
  }

  function getCachedRates(base) {
    if (memoryRates && memoryBase === base) return memoryRates;
    try {
      var raw = localStorage.getItem(RATES_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.base !== base || !parsed.rates) return null;
      if (Date.now() - parsed.ts > RATES_TTL) return null;
      memoryRates = parsed.rates;
      memoryBase = base;
      return parsed.rates;
    } catch (e) {
      return null;
    }
  }

  function setCachedRates(base, rates) {
    memoryRates = rates;
    memoryBase = base;
    try {
      localStorage.setItem(RATES_KEY, JSON.stringify({ base: base, rates: rates, ts: Date.now() }));
    } catch (e) {}
  }

  function fetchRates(base) {
    var cached = getCachedRates(base);
    if (cached) return Promise.resolve(cached);
    if (ratesPromise) return ratesPromise;

    var url = 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/' + base.toLowerCase() + '.min.json';
    ratesPromise = fetch(url, { cache: 'force-cache' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var rates = data && data[base.toLowerCase()] ? data[base.toLowerCase()] : null;
        if (!rates) throw new Error('No rates');
        setCachedRates(base, rates);
        ratesPromise = null;
        return rates;
      })
      .catch(function (err) {
        ratesPromise = null;
        return fetch('https://latest.currency-api.pages.dev/v1/currencies/' + base.toLowerCase() + '.min.json', { cache: 'force-cache' })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var rates = data && data[base.toLowerCase()] ? data[base.toLowerCase()] : null;
            if (!rates) throw err;
            setCachedRates(base, rates);
            return rates;
          });
      });

    return ratesPromise;
  }

  function centsToMajor(cents) {
    return Number(cents) / 100;
  }

  function getPriceElement(node) {
    return node.querySelector('[data-sha-money="price"]');
  }

  function getCompareElement(node) {
    return node.querySelector('[data-sha-money="compare"]');
  }

  function cacheOriginalPrices() {
    document.querySelectorAll('[data-sha-cents]').forEach(function (node) {
      if (node.getAttribute('data-sha-original-ready') === '1') return;
      var priceEl = getPriceElement(node);
      var compareEl = getCompareElement(node);
      if (priceEl) node.setAttribute('data-sha-original-price', priceEl.innerHTML);
      if (compareEl) node.setAttribute('data-sha-original-compare', compareEl.innerHTML);
      node.setAttribute('data-sha-original-ready', '1');
    });
  }

  function convertVisiblePrices(shopCurrency, targetCurrency, rates) {
    cacheOriginalPrices();
    var rate = 1;
    if (targetCurrency !== shopCurrency) {
      rate = rates[targetCurrency.toLowerCase()];
      if (!rate) return false;
    }

    document.querySelectorAll('[data-sha-cents]').forEach(function (node) {
      var cents = node.getAttribute('data-sha-cents');
      var compareCents = node.getAttribute('data-sha-compare-cents');
      var varies = node.getAttribute('data-sha-price-varies') === '1';
      var priceEl = getPriceElement(node);
      var compareEl = getCompareElement(node);

      if (targetCurrency === shopCurrency) {
        if (priceEl && node.hasAttribute('data-sha-original-price')) {
          priceEl.innerHTML = node.getAttribute('data-sha-original-price');
        }
        if (compareEl && node.hasAttribute('data-sha-original-compare')) {
          compareEl.innerHTML = node.getAttribute('data-sha-original-compare');
        }
        return;
      }

      if (priceEl && cents != null) {
        var formatted = moneyFormat(centsToMajor(cents) * rate, targetCurrency);
        priceEl.textContent = varies ? ('From ' + formatted) : formatted;
      }

      if (compareEl && compareCents != null) {
        compareEl.textContent = moneyFormat(centsToMajor(compareCents) * rate, targetCurrency);
      }
    });

    return true;
  }

  function closeDropdown(root) {
    var list = root.querySelector('[data-disclosure-list]');
    var toggle = root.querySelector('[data-disclosure-toggle]');
    if (list) list.classList.remove('disclosure-list--visible');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function updateToggleUI(root, currency, map) {
    var codeEl = root.querySelector('[data-sha-currency-code]');
    var flagEl = root.querySelector('[data-sha-currency-flag]');
    if (codeEl) codeEl.textContent = currency;

    var matchOpt = root.querySelector('[data-sha-currency-option][data-currency="' + currency + '"]');
    var flagKey = matchOpt && matchOpt.getAttribute('data-flag-class')
      ? matchOpt.getAttribute('data-flag-class')
      : (map[currency] || currency.slice(0, 2) || 'us').toLowerCase();

    if (flagEl) {
      flagEl.className = 'currency-flag currency-flag--' + flagKey;
      flagEl.setAttribute('data-flag', currency);
    }

    root.querySelectorAll('[data-sha-currency-option]').forEach(function (opt) {
      var li = opt.closest('.disclosure-list__item');
      var isCurrent = (opt.getAttribute('data-currency') || '').toUpperCase() === currency;
      if (li) li.classList.toggle('disclosure-list__item--current', isCurrent);
      if (isCurrent) opt.setAttribute('aria-current', 'true');
      else opt.removeAttribute('aria-current');
    });
  }

  function applyCurrency(root, currency, opts) {
    opts = opts || {};
    var shopCurrency = (root.getAttribute('data-shop-currency') || '').toUpperCase();
    var defaultCurrency = (root.getAttribute('data-default-currency') || shopCurrency || '').toUpperCase();
    var map = parseCurrencyMap(root);

    if (currency === 'AUTO') {
      currency = defaultCurrency;
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    } else {
      try { localStorage.setItem(STORAGE_KEY, currency); } catch (e) {}
    }

    closeDropdown(root);
    updateToggleUI(root, currency, map);
    root.setAttribute('data-current-currency', currency);

    var cached = getCachedRates(shopCurrency);
    if (cached) {
      convertVisiblePrices(shopCurrency, currency, cached);
      return;
    }

    fetchRates(shopCurrency).then(function (rates) {
      if ((root.getAttribute('data-current-currency') || '') === currency) {
        convertVisiblePrices(shopCurrency, currency, rates);
      }
    }).catch(function () {});
  }

  function refreshPrices() {
    var root = getRoot();
    if (!root) return;

    var currency = (root.getAttribute('data-current-currency') || root.getAttribute('data-default-currency') || shopCurrency || '').toUpperCase();
    var shopCurrency = (root.getAttribute('data-shop-currency') || '').toUpperCase();
    var cached = getCachedRates(shopCurrency);

    if (cached) {
      convertVisiblePrices(shopCurrency, currency, cached);
      return;
    }

    fetchRates(shopCurrency).then(function (rates) {
      convertVisiblePrices(shopCurrency, currency, rates);
    }).catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshPrices, 60);
  }

  function resetPriceCache(scope) {
    var nodes = scope ? scope.querySelectorAll('[data-sha-cents]') : document.querySelectorAll('[data-sha-cents]');
    nodes.forEach(function (node) {
      node.removeAttribute('data-sha-original-ready');
      node.removeAttribute('data-sha-original-price');
      node.removeAttribute('data-sha-original-compare');
    });
  }

  window.ShaCurrencyConverter = {
    refresh: refreshPrices,
    resetCache: resetPriceCache,
    getSelectedCurrency: function () {
      var root = getRoot();
      if (!root) return null;
      return (root.getAttribute('data-current-currency') || '').toUpperCase();
    }
  };

  ready(function () {
    var root = getRoot();
    if (!root) return;

    var map = parseCurrencyMap(root);
    var shopCurrency = (root.getAttribute('data-shop-currency') || '').toUpperCase();
    var defaultCurrency = (root.getAttribute('data-default-currency') || shopCurrency || '').toUpperCase();

    cacheOriginalPrices();
    fetchRates(shopCurrency).catch(function () {});

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-sha-currency-option]');
      if (!option || !root.contains(option)) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var currency = (option.getAttribute('data-currency') || '').toUpperCase();
      applyCurrency(root, currency);
    }, true);

    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}

    if (saved && saved !== 'AUTO' && saved !== defaultCurrency) {
      updateToggleUI(root, saved, map);
      applyCurrency(root, saved, { fromStorage: true });
    } else {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      updateToggleUI(root, defaultCurrency, map);
      root.setAttribute('data-current-currency', defaultCurrency);
    }

    document.addEventListener('page:loaded', scheduleRefresh);
    document.addEventListener('recommendations:loaded', scheduleRefresh);
    document.addEventListener('quickview:loaded', scheduleRefresh);
    document.addEventListener('cart:updated', scheduleRefresh);

    var observer = new MutationObserver(function (mutations) {
      var hasNewPrices = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-sha-cents]')) hasNewPrices = true;
          if (node.querySelector && node.querySelector('[data-sha-cents]')) hasNewPrices = true;
        });
      });
      if (hasNewPrices) scheduleRefresh();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
